var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.31038 14.6969C9.44954 14.6629 9.58871 14.6258 9.72787 14.5918C11.4565 14.1496 13.4202 13.6455 15.4582 13.7043C15.585 12.7332 16.4137 11.9818 17.4219 11.9818V6.53597C16.3302 6.53597 15.4458 5.65153 15.4427 4.5599C13.9893 4.50733 12.4492 4.85368 10.6896 5.30209C10.5505 5.3361 10.4113 5.37321 10.2721 5.41032C8.54346 5.85254 6.57975 6.35661 4.54183 6.29785C4.41504 7.26888 3.58317 8.02035 2.57812 8.02035V13.4631C3.66976 13.4631 4.5542 14.3475 4.55729 15.4391C6.01074 15.4917 7.55078 15.1453 9.31038 14.6969ZM1.09375 15.1175V5.57731C1.09375 4.82894 1.87923 4.33106 2.59049 4.52588C5.05827 5.20622 7.52913 4.57536 10 3.94759C12.6873 3.26416 15.3747 2.57764 18.062 3.5765C18.5908 3.77133 18.9062 4.30941 18.9062 4.88151V14.4217C18.9062 15.1732 18.1208 15.668 17.4126 15.4731C14.9417 14.7928 12.4709 15.4237 10 16.0514C7.31266 16.7349 4.62533 17.4214 1.93799 16.4225C1.40918 16.2277 1.09375 15.6896 1.09375 15.1175ZM10 12.9683C8.63314 12.9683 7.52604 11.6385 7.52604 9.99952C7.52604 8.36052 8.63314 7.03077 10 7.03077C11.3669 7.03077 12.474 8.36052 12.474 9.99952C12.474 11.6385 11.3669 12.9683 10 12.9683Z",
    fill: "#526077"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.7cef18d293836d0ce2d8c5544ae30b1a.svg";
export { ForwardRef as ReactComponent };